const Style = {

  base: 'relative block text-red-500 text-xs mt-1 mb-3 px-0 py-0 bg-transparent'

}

export default Style;
